import { useEffect } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import Heading from 'components/heading/heading'
import Meta from 'components/meta/meta'
import Review from 'components/review/review'
import Infinite from 'components/infinite/infinite'
import styles from 'styles/page/atsiliepimai.module.scss'
import useAppState from 'utils/state'
import { cn, getRoute } from 'utils/helpers'
import { useModal } from 'components/modals/provider'
import { getData } from 'utils/api'

const LoginRequired = dynamic(() => import('components/modals/login-required/login-required'))
const ReviewForm = dynamic(() => import('components/modals/review-form/review-form'))

const holder = ({ items }) => {
    return (
        <div className="mb72">
            {items.map(item => (
                <Review key={item.id} item={item} />
            ))}
        </div>
    )
}

export default function Page({ total }) {
    const { user } = useAppState()
    const { showModal } = useModal()

    useEffect(() => {
        if (window.location.search === '?o') {
            showModal(ReviewForm)
        }
    }, [])

    const handleClick = e => {
        e.preventDefault()
        if (user) {
            showModal(ReviewForm)
        } else {
            showModal(LoginRequired, { text: 'Pateikti atsiliepimus gali tik registruoti lietuviskapreke.lt nariai.' })
        }
    }

    return (
        <>
            <Meta title="Pirkėjų atsiliepimai" description="Lietuviskapreke.lt lankytojų ir pirkėjų atsiliepimai." />
            <Heading tag="h1" size="36" center className="mb18">
                Pirkėjų atsiliepimai
            </Heading>
            <div className={cn(styles.links, 'mb72')}>
                <a onClick={handleClick}>Rašyti atsiliepimą</a>
                <i>|</i>
                <Link href={getRoute('reviews')}>
                    <a>Iš viso: {total}</a>
                </Link>
            </div>
            <Infinite endpoint="reviews/general" component={Review} holder={holder} />
        </>
    )
}

export async function getStaticProps() {
    return await getData('reviews-info')
}
